import { isEmpty } from 'lodash-es';
import { type ReadonlyURLSearchParams } from 'next/navigation.js';
import { DISCOVER_FILTERS } from '#hooks/useDiscoverFiltersParam.ts';
import { type DiscoverMovieFilters, type DiscoverTvFilters } from '#types.ts';

export const buildDiscoverFieldsUrl = (
  filterValues: DiscoverMovieFilters | DiscoverTvFilters | undefined,
  pathname: string,
  searchParams: URLSearchParams | ReadonlyURLSearchParams,
) => {
  const newSearchParams = new URLSearchParams(searchParams.toString());

  if (filterValues && !isEmpty(filterValues)) {
    if (newSearchParams.has(DISCOVER_FILTERS)) {
      newSearchParams.set(DISCOVER_FILTERS, JSON.stringify(filterValues));
    } else {
      newSearchParams.append(DISCOVER_FILTERS, JSON.stringify(filterValues));
    }
  } else if (newSearchParams.has(DISCOVER_FILTERS)) {
    newSearchParams.delete(DISCOVER_FILTERS);
  }

  return newSearchParams.size > 0 ? `${pathname}?${newSearchParams.toString()}` : pathname;
};
